import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFIcon,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { logo, hero, mobileHero, mobileLogo } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="105VH"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
          column
          justifyStart
          alignCenter
        >
          <CFView w="100%" column center mv="20px">
            <CFImage src={mobileLogo} w="75%" alt="Promotions" />
          </CFView>

          <CFView
            center
            br="20px"
            bc="black"
            bw="3px"
            pv="5px"
            ph="12px"
            pointer
            hover
            zIndex={99}
          >
            <CFView color="black" xBold mb="2px">
              NEW WESTMINSTER
            </CFView>
          </CFView>
          <CFView textCenter column center w="100%" ph="7%" pt="10px" pb="5px">
            <CFView column center>
              <CFText color="white" h1 raleway bold></CFText>
            </CFView>
            <CFView mt="8px" pulsate>
              <OrderPickupButton />
            </CFView>
            <CFView mt="8px">
              <OrderDeliveryButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="690px"
          w="100%"
          image={`url(${hero}) center / cover no-repeat`}
          style={{ backgroundAttachment: 'fixed' }}
          zIndex={90}
          column
          justifyBetween
          alignCenter
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
          maxWidth="1400px"
        >
          <CFView w="100%" column justifyStart bg="rgba(0,0,0,.7)">
            <CFView ml="5%" mt="9px" mb="5px">
              <CFImage src={logo} w="50%" maxWidth="230px" alt="Promotions" />
            </CFView>
          </CFView>
          <CFView
            row
            center
            alignCenter
            ph="65px"
            bg="rgb(0,0,0,.7)"
            style={{
              backdropFilter: 'blur(10px)',
              webkitBackdropFilter: 'blur(10px)',
            }}
          >
            <CFView mt="7px" mb="3px" pulsate>
              <OrderPickupButton />
            </CFView>
            <CFView mt="7px" mb="3px" ml="20px">
              <OrderDeliveryButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
